import Home from './Home';
import Categories from './Categories';
import Studios from './Studios';
import Rentals from './Rentals';
import Technicians from './Technicians';
import AboutUs from './AboutUs';
import Cafe from './Cafe';
import TermsAndConditions from './TermsAndConditions';

export { Home, Categories, Studios, Rentals, Technicians, AboutUs, Cafe, TermsAndConditions };



// WEBPACK FOOTER //
// ./src/pages/index.js